export const periodList = ['7 days', '1 Month', '3 Months', '1 Year']
export const textFormatList = ['Export PDF', 'Export Excel', 'Export CSV']
export const analyticsData = {
    uncomfortableEmotionsList: ['sad', 'angry', 'grumpy'],
    checkIns: 20,
    classAverage: 100,
    completedActivities: 3,
    totalActivities: 100,
    activitiesClassAverage: 68,
    comfortableEmotions: 4,
    uncomfortableEmotions: 16,
    comfortableEmotionsClassAverage: 65,
    uncomfortableEmotionsClassAverage: 35,
    uncomfortableEmotionsPeriodList: [
        { emotion: 'sad', reasons: ['Family', 'Myself', 'Wellbeing'], date: new Date('2024-10-10') },
        { emotion: 'angry', reasons: ['Family', 'School', 'Wellbeing'], date: new Date('2024-10-11') },
        { emotion: 'grumpy', reasons: ['Family', 'School', 'Wellbeing'], date: new Date('2024-10-11') },
        { emotion: 'sad', reasons: ['Family', 'Myself', 'Sleep'], date: new Date('2024-10-10') },
        { emotion: 'grumpy', reasons: ['Family', 'School', 'Wellbeing'], date: new Date('2024-10-12') },
        { emotion: 'sad', reasons: ['Family', 'Myself', 'Sleep'], date: new Date('2024-10-10') },
    ],
    comfortableEmotionsPeriodList: [
        { emotion: 'happy', reasons: ['Family', 'Myself', 'Wellbeing'], date: new Date() },
        { emotion: 'happy', reasons: ['Family', 'School', 'Wellbeing'], date: new Date() },
        { emotion: 'ok', reasons: ['Family', 'School', 'Sleep'], date: new Date() },
        { emotion: 'happy', reasons: ['Family', 'Myself', 'Sleep'], date: new Date() },
    ],
}

export const studentAlerts = [
    {
        feedbacks: [
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728086461522,
                type: 'daily',
                message: '',
                emotion: 'stressed',
                hashcode: 'asdfasfas',
                reasons: ['myself', 'social media', 'health'],
                day_code: '2024-10-05',
                id: '670081bd5d5b629962d469ed',
            },
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728000061461,
                type: 'daily',
                message: '',
                emotion: 'numb',
                hashcode: 'asdfasfas',
                reasons: ['school', 'wellbeing', 'sleep'],
                day_code: '2024-10-04',
                id: '66ff303dfb30b59cf09d76af',
            },
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1727913661735,
                type: 'daily',
                message: '',
                emotion: 'worried',
                hashcode: 'asdfasfas',
                reasons: ['achievement', 'social media', 'family'],
                day_code: '2024-10-03',
                id: '66fddebd3b1f606b7e536314',
            },
        ],
        user_id: '5f643e2701f2a27accc637ee',
        user: {
            last_name: 'Cuban',
            first_name: 'John',
        },
        type: 'multipleNegativeEmotions',
        created_date: 1727913661735,
        state: 'completed',
        activityHistory: [
            {
                user: { first_name: 'Zoran', last_name: 'Marcelo' },
                assignedTo: { first_name: 'Sasa', last_name: 'Matic' },
                type: 'assignedAction',
                message: 'Text message from student',
                created_date: new Date(),
            },
        ],
        keyword: 'self harm',
    },
    {
        feedbacks: [
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728086461522,
                type: 'daily',
                message: '',
                emotion: 'stressed',
                hashcode: 'asdfasfas',
                reasons: ['myself', 'social media', 'health'],
                day_code: '2024-10-05',
                id: '670081bd5d5b629962d469ed',
            },
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728000061461,
                type: 'daily',
                message: '',
                emotion: 'numb',
                hashcode: 'asdfasfas',
                reasons: ['school', 'wellbeing', 'sleep'],
                day_code: '2024-10-04',
                id: '66ff303dfb30b59cf09d76af',
            },
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1727913661735,
                type: 'daily',
                message: '',
                emotion: 'worried',
                hashcode: 'asdfasfas',
                reasons: ['achievement', 'social media', 'family'],
                day_code: '2024-10-03',
                id: '66fddebd3b1f606b7e536314',
            },
        ],
        user_id: '5f643e2701f2a27accc637ee',
        user: {
            last_name: 'Smith',
            first_name: 'John',
        },
        type: 'multipleNegativeEmotions',
        created_date: 1727913661735,
        state: 'assignedToMe',
        activityHistory: [
            {
                user: { first_name: 'Zoran', last_name: 'Marcelo' },
                type: 'actionTaken',
                message:
                    'Text message from student Text message from student Text message from student Text message from student Text message from student Text message from student Text message from student Text message from student Text message from student Text message from student',
                created_date: new Date(),
            },
        ],
    },
    {
        feedbacks: [
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728086461522,
                type: 'daily',
                message: '',
                emotion: 'stressed',
                hashcode: 'asdfasfas',
                reasons: ['myself', 'social media', 'health'],
                day_code: '2024-10-05',
                id: '670081bd5d5b629962d469ed',
            },
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728000061461,
                type: 'daily',
                message: '',
                emotion: 'numb',
                hashcode: 'asdfasfas',
                reasons: ['school', 'wellbeing', 'sleep'],
                day_code: '2024-10-04',
                id: '66ff303dfb30b59cf09d76af',
            },
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1727913661735,
                type: 'daily',
                message: '',
                emotion: 'worried',
                hashcode: 'asdfasfas',
                reasons: ['achievement', 'social media', 'family'],
                day_code: '2024-10-03',
                id: '66fddebd3b1f606b7e536314',
            },
        ],
        user_id: '5f643e2701f2a27accc637ee',
        user: {
            last_name: 'Cuban',
            first_name: 'John',
        },
        type: 'multipleNegativeEmotions',
        created_date: 1727913661735,
        state: 'notAssigned',
        keyword: 'sexual',
    },
]

export const detailedEmotionsDummy = [
    { _id: '2024-11-02', day_code: '2024-11-02', feedback: [] },
    { _id: '2024-11-01', day_code: '2024-11-01', feedback: [] },
    { _id: '2024-10-31', day_code: '2024-10-31', feedback: [] },
    { _id: '2024-10-30', day_code: '2024-10-30', feedback: [] },
    { _id: '2024-10-29', day_code: '2024-10-29', feedback: [] },
    { _id: '2024-10-28', day_code: '2024-10-28', feedback: [] },
    { _id: '2024-10-27', day_code: '2024-10-27', feedback: [] },
]
export const detailedEmotionsOverallDummy = [
    { _id: '01/24', label_name: '01/24', comfortable: 0, uncomfortable: 10, total_emotions: 1 },
    { _id: '02/24', label_name: '02/24', comfortable: 10, uncomfortable: 2, total_emotions: 1 },
    { _id: '03/24', label_name: '03/24', comfortable: 12, uncomfortable: 24, total_emotions: 1 },
    { _id: '04/24', label_name: '04/24', comfortable: 30, uncomfortable: 10, total_emotions: 1 },
    { _id: '05/24', label_name: '05/24', comfortable: 5, uncomfortable: 20, total_emotions: 1 },
    { _id: '06/24', label_name: '06/24', comfortable: 12, uncomfortable: 10, total_emotions: 1 },
    { _id: '07/24', label_name: '07/24', comfortable: 21, uncomfortable: 11, total_emotions: 1 },
    { _id: '08/24', label_name: '08/24', comfortable: 18, uncomfortable: 24, total_emotions: 0 },
    { _id: '09/24', label_name: '09/24', comfortable: 21, uncomfortable: 15, total_emotions: 1 },
    { _id: '10/24', label_name: '10/24', comfortable: 20, uncomfortable: 8, total_emotions: 1 },
    { _id: '11/24', label_name: '11/24', comfortable: 16, uncomfortable: 10, total_emotions: 1 },
    { _id: '12/24', label_name: '12/24', comfortable: 21, uncomfortable: 11, total_emotions: 1 },
]

export const detailedEmotionTrendsDummy = [
    { _id: '01/24', label_name: '1-7 Jul.', comfortable: 0, uncomfortable: 10, total_emotions: 1 },
    { _id: '02/24', label_name: '8-14 Jul.', comfortable: 10, uncomfortable: 2, total_emotions: 1 },
    { _id: '03/24', label_name: '15-21 Jul.', comfortable: 12, uncomfortable: 24, total_emotions: 1 },
    { _id: '04/24', label_name: '22-28 Jul.', comfortable: 30, uncomfortable: 10, total_emotions: 1 },
    { _id: '05/24', label_name: '29-31 Jul.', comfortable: 5, uncomfortable: 20, total_emotions: 1 },
    { _id: '01/24', label_name: '1-7 Jul.', comfortable: 0, uncomfortable: 10, total_emotions: 1 },
    { _id: '02/24', label_name: '8-14 Jul.', comfortable: 10, uncomfortable: 2, total_emotions: 1 },
    { _id: '03/24', label_name: '15-21 Jul.', comfortable: 12, uncomfortable: 24, total_emotions: 1 },
    { _id: '04/24', label_name: '22-28 Jul.', comfortable: 30, uncomfortable: 10, total_emotions: 1 },
    { _id: '05/24', label_name: '29-31 Jul.', comfortable: 5, uncomfortable: 20, total_emotions: 1 },
    { _id: '01/24', label_name: '1-7 Jul.', comfortable: 0, uncomfortable: 10, total_emotions: 1 },
    { _id: '02/24', label_name: '8-14 Jul.', comfortable: 10, uncomfortable: 2, total_emotions: 1 },
]

export const barChartList = [
    {
        bad: [
            { emotion: 'angry', message: ' lorem ipsum bla bla lorem ipsum bla bla lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla blaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa' },
        ],
        good: [
            { emotion: 'happy', message: 'lorem ipsum bla bla' },

            { emotion: 'happy', message: 'lorem ipsum bla bla' },
        ],
        date: new Date(),
    },
    {
        bad: [{ emotion: 'angry', message: 'lorem ipsum bla bla' }],
        good: [
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
        ],
        date: new Date(),
    },
    {
        bad: [],
        good: [],
        date: new Date(),
    },
    {
        bad: [
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
        ],
        good: [
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
        ],
        date: new Date(),
    },
    {
        bad: [
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
        ],
        good: [
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
        ],
        date: new Date(),
    },
    {
        bad: [
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
        ],
        good: [{ emotion: 'happy', message: 'lorem ipsum bla bla' }],
        date: new Date(),
    },
    {
        bad: [
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
        ],
        good: [],
        date: new Date(),
    },
    {
        bad: [
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
        ],
        good: [{ emotion: 'happy', message: 'lorem ipsum bla bla' }],
        date: new Date(),
    },
    {
        bad: [
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
        ],
        good: [
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
        ],
        date: new Date(),
    },
    {
        bad: [
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
        ],
        good: [{ emotion: 'happy', message: 'lorem ipsum bla bla' }],
        date: new Date(),
    },
    {
        bad: [
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
        ],
        good: [],
        date: new Date(),
    },
    {
        bad: [
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
        ],
        good: [{ emotion: 'happy', message: 'lorem ipsum bla bla' }],
        date: new Date(),
    },
    {
        bad: [
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
            { emotion: 'angry', message: 'lorem ipsum bla bla' },
        ],
        good: [{ emotion: 'happy', message: 'lorem ipsum bla bla' }],
        date: new Date(),
    },
    {
        bad: [],
        good: [
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
        ],
        date: new Date(),
    },
    {
        bad: [{ emotion: 'angry', message: 'lorem ipsum bla bla' }],
        good: [
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
        ],
        date: new Date(),
    },
    {
        bad: [
            { emotion: 'angry', message: 'lorem ipsum bla bla afdsfsdasdasdfsdfasdasdf asdfasdsdfsdfasfasdfasdf' },
            { emotion: 'angry', message: 'lorem ipsum bla bla afdsfsdasdasdfsdfasdasdf asdfasdsdfsdfasfasdfasdf' },
        ],
        good: [{ emotion: 'happy', message: 'lorem ipsum bla bla' }],
        date: new Date(),
    },
    {
        bad: [{ emotion: 'angry', message: 'lorem ipsum bla bla' }],
        good: [
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
            { emotion: 'happy', message: 'lorem ipsum bla bla' },
        ],
        date: new Date(),
    },
    {
        bad: [
            { emotion: 'angry', message: 'lorem ipsum bla bla afdsfsdasdasdfsdfasdasdf asdfasdsdfsdfasfasdfasdf' },
            { emotion: 'angry', message: 'lorem ipsum bla bla afdsfsdasdasdfsdfasdasdf asdfasdsdfsdfasfasdfasdf' },
        ],
        good: [{ emotion: 'happy', message: 'lorem ipsum bla bla' }],
        date: new Date(),
    },
]
export const assignedLoadingList = [
    {
        assignedTo: {
            first_name: 'John',
            last_name: 'Cuban',
        },
        actionMessage: 'Talk to him',
        assignedBy: {
            first_name: 'John',
            last_name: 'Cuban',
        },
        actionTaken: true,
        feedbackId: '6724284d0a3987a43b6fff42',
        studentId: '5f643e2701f2a27accc637ee',
        seen: false,
        created_date: 1730659620000,
        first_name: 'Zoran',
        last_name: 'Marcelo',
    },
    {
        assignedTo: {
            first_name: 'Mark',
            last_name: 'Johnson',
        },
        actionMessage: 'Consider taking him to counsellor and have a chat',
        assignedBy: {
            first_name: 'John',
            last_name: 'Cuban',
        },
        actionTaken: true,
        feedbackId: '6724284d0a3987a43b6fff42',
        studentId: '5f643e2701f2a27accc637ee',
        seen: false,
        created_date: 1730659620000,
        first_name: 'John',
        last_name: 'Wick',
    },
]

export const participationList = [
    {
        type: 'survey',
        publicationDate: 1730595662098,
        assignedFrom: 'S.Ivanisevic',
        message: 'lorem ipsum ',
        participationPercentage: 90,
        user_info: {
            first_name: 'Zoran',
            last_name: 'Marcelo',
        },
        title: 'Share your thoughts...',
    },
    {
        type: 'journal',
        publicationDate: 1730595662098,
        assignedFrom: 'S.Ivanisevic',
        message: 'lorem ipsum ',
        participationPercentage: 30,
        user_info: {
            first_name: 'Zoran',
            last_name: 'Marcelo',
        },
        title: 'Share your thoughts...',
    },
]

export const studentData = {
    id: '6504110c88fc9c8a52accc6c',
    emotion: 'false',
    year: 'Year 1',
    class: 'Class 1B',
    teacher: 'Name Surname',
    gender: null,
    comfortable: 30,
    uncomfortable: -30,
}
export const STUDENT_TARGET = ['Class average', 'Grade average', 'School average']
export const STUDENT_TARGET_VALUES = [
    { label: 'Class average', code: 'class' },
    { label: 'Grade average', code: 'grade' },
    { label: 'School average', code: 'school' },
]

export const STUDENT_PERIOD = ['Last month', 'Last 3 months', 'Last year']
export const STUDENT_PERIOD_VALUES = [
    { label: 'Last month', numberOfDays: 30 },
    { label: 'Last 3 months', numberOfDays: 91 },
    { label: 'Last year', numberOfDays: 365 },
]

export const student_reasons_list = {
    comfortable: {
        reasons: [
            {
                reason: 'achievement',
                count: 4,
                students: [
                    { name: 'John Doe', number: 2 },
                    { name: 'John Wick', number: 1 },
                    { name: 'Steven Doe', number: 1 },
                ],
            },
            {
                reason: 'wellbeing',
                count: 3,
                students: [
                    { name: 'John Doe', number: 2 },
                    { name: 'John Wick', number: 1 },
                ],
            },
            {
                reason: 'health',
                count: 3,
                students: [
                    { name: 'John Doe', number: 2 },
                    { name: 'John Wick', number: 1 },
                ],
            },
            {
                reason: 'school',
                count: 2,
                students: [
                    { name: 'John Doe', number: 1 },
                    { name: 'John Wick', number: 1 },
                ],
            },
            { reason: 'social media', count: 1, students: [{ name: 'John Wick', number: 1 }] },
            { reason: 'family', count: 1, students: [{ name: 'John Wick', number: 1 }] },
            { reason: 'myself', count: 1, students: [{ name: 'John Wick', number: 1 }] },
        ],
        total: 15,
    },
    uncomfortable: {
        reasons: [
            {
                reason: 'social media',
                count: 3,
                students: [
                    { name: 'John Doe', number: 2 },
                    { name: 'John Wick', number: 1 },
                ],
            },
            {
                reason: 'wellbeing',
                count: 2,
                students: [
                    { name: 'John Doe', number: 1 },
                    { name: 'John Wick', number: 1 },
                ],
            },
            { reason: 'health', count: 1, students: [{ name: 'John Wick', number: 1 }] },
            { reason: 'school', count: 1, students: [{ name: 'John Wick', number: 1 }] },
            { reason: 'social media', count: 1, students: [{ name: 'John Wick', number: 1 }] },
            { reason: 'family', count: 1, students: [{ name: 'John Wick', number: 1 }] },
        ],
        total: 9,
    },
}
export const classAlerts = [
    {
        feedbacks: [
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728086461522,
                type: 'daily',
                message: '',
                emotion: 'stressed',
                hashcode: 'asdfasfas',
                reasons: ['myself', 'social media', 'health'],
                day_code: '2024-10-05',
                id: '670081bd5d5b629962d469ed',
            },
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728000061461,
                type: 'daily',
                message: '',
                emotion: 'numb',
                hashcode: 'asdfasfas',
                reasons: ['school', 'wellbeing', 'sleep'],
                day_code: '2024-10-04',
                id: '66ff303dfb30b59cf09d76af',
            },
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1727913661735,
                type: 'daily',
                message: '',
                emotion: 'worried',
                hashcode: 'asdfasfas',
                reasons: ['achievement', 'social media', 'family'],
                day_code: '2024-10-03',
                id: '66fddebd3b1f606b7e536314',
            },
        ],
        user_id: '5f643e2701f2a27accc637ee',
        user: {
            last_name: 'Cuban',
            first_name: 'John',
        },
        type: 'multipleNegativeEmotions',
        created_date: 1727913661735,
        state: 'completed',
        activityHistory: [
            {
                user: { first_name: 'Zoran', last_name: 'Marcelo' },
                assignedTo: { first_name: 'Sasa', last_name: 'Matic' },
                type: 'assignedAction',
                message: 'Text message from student',
                created_date: new Date(),
            },
            {
                user: { first_name: 'Zoran', last_name: 'Marcelo' },
                message: 'aaaa Text message from student',
                created_date: new Date(),
                assignedTo: { first_name: 'Sasa', last_name: 'Matic', id: '623ae03948561b5febd9492d' },
                type: 'assignedAction',
            },
        ],
    },
    {
        feedbacks: [
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728086461522,
                type: 'daily',
                message: '',
                emotion: 'stressed',
                hashcode: 'asdfasfas',
                reasons: ['myself', 'social media', 'health'],
                day_code: '2024-10-05',
                id: '670081bd5d5b629962d469ed',
            },
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728000061461,
                type: 'daily',
                message: '',
                emotion: 'numb',
                hashcode: 'asdfasfas',
                reasons: ['school', 'wellbeing', 'sleep'],
                day_code: '2024-10-04',
                id: '66ff303dfb30b59cf09d76af',
            },
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1727913661735,
                type: 'daily',
                message: '',
                emotion: 'worried',
                hashcode: 'asdfasfas',
                reasons: ['achievement', 'social media', 'family'],
                day_code: '2024-10-03',
                id: '66fddebd3b1f606b7e536314',
            },
        ],
        user_id: '5f643e2701f2a27accc637ee',
        user: {
            last_name: 'Marcelo',
            first_name: 'Zoran',
        },
        type: 'multipleNegativeEmotions',
        created_date: 1727813661735,
        state: 'assignedToMe',
        activityHistory: [
            {
                user: { first_name: 'Zoran', last_name: 'Marcelo' },
                type: 'actionTaken',
                message: 'Text message from student',
                created_date: new Date(),
            },
            {
                user: { first_name: 'Zoran', last_name: 'Marcelo' },
                message: 'aaaa Text message from student',
                created_date: new Date(),
                assignedTo: { first_name: 'Sasa', last_name: 'Matic', id: '623ae03948561b5febd9492d' },
                type: 'assignedAction',
            },
        ],
    },
    {
        feedbacks: [
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728086461522,
                type: 'daily',
                message: '',
                emotion: 'stressed',
                hashcode: 'asdfasfas',
                reasons: ['myself', 'social media', 'health'],
                day_code: '2024-10-05',
                id: '670081bd5d5b629962d469ed',
            },
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728000061461,
                type: 'daily',
                message: '',
                emotion: 'numb',
                hashcode: 'asdfasfas',
                reasons: ['school', 'wellbeing', 'sleep'],
                day_code: '2024-10-04',
                id: '66ff303dfb30b59cf09d76af',
            },
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1727913661735,
                type: 'daily',
                message: '',
                emotion: 'worried',
                hashcode: 'asdfasfas',
                reasons: ['achievement', 'social media', 'family'],
                day_code: '2024-10-03',
                id: '66fddebd3b1f606b7e536314',
            },
        ],
        user_id: '5f643e2701f2a27accc637ee',
        user: {
            last_name: 'Wick',
            first_name: 'John',
        },
        type: 'multipleNegativeEmotions',
        created_date: 1726913661735,
        state: 'notAssigned',
    },
    {
        feedbacks: [
            {
                user_id: '5f643e2701f2a27accc637ee',
                created_date: 1728086461522,
                type: 'daily',
                message: '',
                emotion: 'stressed',
                hashcode: 'asdfasfas',
                reasons: ['myself', 'social media', 'health'],
                day_code: '2024-10-05',
                id: '670081bd5d5b629962d469ed',
            },
        ],
        user_id: '5f643e2701f2a27accc637ee',
        user: {
            last_name: 'Malone',
            first_name: 'John',
        },
        type: 'multipleNegativeEmotions',
        created_date: 1725913661735,
        state: 'completed',
        activityHistory: [
            {
                user: { first_name: 'Zoran', last_name: 'Marcelo' },
                assignedTo: { first_name: 'Sasa', last_name: 'Matic' },
                type: 'assignedAction',
                message: 'Text message from student',
                created_date: new Date(),
            },
        ],
    },
]

export const classEmotionalWellbeing = [
    {
        user_info: {
            first_name: 'Zoran',
            last_name: 'Marcelo',
        },
        comfortable: 27,
        comfortableReasons: [
            { name: 'health', count: 19 },
            { name: 'school', count: 5 },
            { name: 'sleep', count: 3 },
        ],
        uncomfortable: 34,
        uncomfortableReasons: [
            { name: 'family', count: 18 },
            { name: 'myself', count: 15 },
            { name: 'wellbeing', count: 1 },
        ],
    },
    {
        user_info: {
            first_name: 'Don',
            last_name: 'Johnson',
        },
        comfortable: 17,
        comfortableReasons: [
            { name: 'health', count: 10 },
            { name: 'school', count: 5 },
            { name: 'sleep', count: 2 },
        ],
        uncomfortable: 13,
        uncomfortableReasons: [
            { name: 'family', count: 10 },
            { name: 'myself', count: 2 },
            { name: 'wellbeing', count: 1 },
        ],
    },
    {
        user_info: {
            first_name: 'John',
            last_name: 'Wick',
        },
        comfortable: 13,
        comfortableReasons: [
            { name: 'health', count: 10 },
            { name: 'school', count: 2 },
            { name: 'sleep', count: 1 },
        ],
        uncomfortable: 17,
        uncomfortableReasons: [
            { name: 'family', count: 10 },
            { name: 'myself', count: 5 },
            { name: 'wellbeing', count: 2 },
        ],
    },
    {
        user_info: {
            first_name: 'Alexander',
            last_name: 'Wolfic',
        },
        comfortable: 13,
        comfortableReasons: [
            { name: 'health', count: 6 },
            { name: 'school', count: 5 },
            { name: 'sleep', count: 2 },
        ],
        uncomfortable: 28,
        uncomfortableReasons: [
            { name: 'family', count: 15 },
            { name: 'myself', count: 12 },
            { name: 'wellbeing', count: 1 },
        ],
    },
    {
        user_info: {
            first_name: 'John',
            last_name: 'Wick',
        },
        comfortable: 11,
        comfortableReasons: [
            { name: 'health', count: 8 },
            { name: 'school', count: 2 },
            { name: 'sleep', count: 1 },
        ],
        uncomfortable: 17,
        uncomfortableReasons: [
            { name: 'family', count: 10 },
            { name: 'myself', count: 5 },
            { name: 'wellbeing', count: 2 },
        ],
    },
    {
        user_info: {
            first_name: 'Zoran',
            last_name: 'Marcelo',
        },
        comfortable: 7,
        comfortableReasons: [
            { name: 'health', count: 3 },
            { name: 'school', count: 3 },
            { name: 'sleep', count: 1 },
        ],
        uncomfortable: 8,
        uncomfortableReasons: [
            { name: 'family', count: 5 },
            { name: 'myself', count: 2 },
            { name: 'wellbeing', count: 1 },
        ],
    },
]
